export default __webpack_public_path__ + "3ff35b1a522e642a34c5a02115712ba7.png";